import * as React from 'react';
import { flow, get, isEmpty } from 'lodash';
import { formValueSelector, submit, reset } from 'redux-form';
import { Button, Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import SaveQuoteModalForm from './components/SaveQuoteModalForm';
import { bindActionCreators } from 'redux';
import { IQuoteActions, IQuoteState } from '../../../../services/quote/models';
import { actions as quoteActions } from '../../../../services/quote/reducer';
import { push } from 'react-router-redux';
import {
  actions as authActions,
  IAuthActions,
} from '../../../../services/auth/reducer';
import { IAuthState } from '../../../../services/auth/models';
import { withRouter } from 'react-router-dom';

interface ISaveQuoteModalProps {
  auth: IAuthState;
  quote: IQuoteState;
  password: string;
  passwordConfirmation: string;
  fireEmail: any;
  actions: {
    submit(name: string);
    push(path: string);
    quote: IQuoteActions;
    auth: IAuthActions;
  };
}

interface ISaveQuoteModalStates {
  showSaveQuoteModal: boolean;
  isQuoteSaved: boolean;
}

class SaveQuoteModal extends React.Component<ISaveQuoteModalProps, ISaveQuoteModalStates> {
  public state = {
    showSaveQuoteModal: false,
    isQuoteSaved: false,
  };

  public componentWillReceiveProps(nextProps) {
    const { location } = this.props;

    if (nextProps.location.pathname !== location.pathname) {
      this.setState({
        showSaveQuoteModal: false,
      });
    }
  }

  private openSaveQuoteModal = () => {
    this.setState({
      showSaveQuoteModal: true,
    });
  }

  private handleSubmit = ({ password, passwordConfirmation }) => {
    const { actions, dispatch, change, quote, fireEmail } = this.props;
    dispatch(change('createAccount', true));
    dispatch(change('emailSend', true));
    actions.quote.setPassword(password, passwordConfirmation);
    fireEmail();

    if (quote.isRetrievingQuote) {
      actions.quote.saveQuote(true);
    }

    if (!quote.isRetrievingQuote) {
      const errors = (data) => get(data, 'response.data.errors');
      actions.quote.submitForm(null, true, true, false, true).then((data) => {
        if (isEmpty(errors(data))) {
          actions.quote.clearErrors();
          this.setState({
            isQuoteSaved: true,
          });
        }
      });
    }
  }

  private handleCloseModal = () => {
    const { dispatch, change, actions } = this.props;
    actions.quote.clearErrors();
    dispatch(reset('save_quote'));
    this.setState({
      showSaveQuoteModal: false,
      isQuoteSaved: false,
    });

    dispatch(change('generateDocuments', false));
    dispatch(change('emailSend', false));
  }

  private handleGoToMyAccount = () => {
    const { actions, dispatch, change } = this.props;

    dispatch(change('generateDocuments', false));
    dispatch(change('emailSend', false));
    actions.push('/account/summary');

    this.setState({
      showSaveQuoteModal: false,
      isQuoteSaved: false,
    });
  }

  private handleEditDetails = () => {
    const { history } = this.props;

    this.setState({
      showSaveQuoteModal: false,
    });

    history.push('/');
  }

  public render() {
    const { quote, password, passwordConfirmation, channel } = this.props;
    const { showSaveQuoteModal, isQuoteSaved } = this.state;
    const customer = quote.customer;
    return (
      <div>
        <Button
          bsStyle="default"
          type="button"
          block={true}
          className="save-quote-btn btn-remove-border"
          onClick={this.openSaveQuoteModal}
          disabled={!customer}
        >
          Save Your Quote
        </Button>
        <Modal
          show={showSaveQuoteModal}
          onHide={this.handleCloseModal}>
          <Modal.Header closeButton={true}>
            <Modal.Title>Save Your Quote</Modal.Title>
          </Modal.Header>
          <SaveQuoteModalForm
            quoteErrors={get(quote, 'errors.setPassword.errors')}
            onSubmit={this.handleSubmit}
            initialValues={{ password, passwordConfirmation }}
            onCloseModal={this.handleCloseModal}
            onGoToMyAccount={this.handleGoToMyAccount}
            onEditDetails={this.handleEditDetails}
            isQuoteSaved={isQuoteSaved}
          />
        </Modal>
      </div>
    );
  }
}

let selector;

export default flow([
  (component) => {
    selector = formValueSelector('quote');

    return component;
  },
  connect(
    (state) => {
      const password = selector(state, 'password');
      const passwordConfirmation = selector(state, 'passwordConfirmation');

      return {
        auth: state.auth,
        quote: state.quote,
        password,
        passwordConfirmation,
      };
    },
    (dispatch) => ({
      actions: {
        push: bindActionCreators(push, dispatch),
        submit: bindActionCreators(submit, dispatch),
        auth: bindActionCreators({ ...authActions }, dispatch),
        quote: bindActionCreators({ ...quoteActions }, dispatch),
      },
    }),
  ),
  withRouter,
])(SaveQuoteModal);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/components/SaveQuoteModal/index.tsx